(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-check-out"]) return;
  try {
    
  const checkoutButtonElement = document.getElementById('checkout-button');

  /** Script to Handle Disabling of The Checkout Button + Updating Whether The Cart Has a Subscription & The First Cart Item's Quantity **/

  // Adds event listener to when the cart is updated.
  window.addEventListener('cart_changed', ({ detail }) => {
    if (detail.cart.item_count === 0) {
      checkoutButtonElement.classList.add('opacity-50', 'pointer-events-none');
    }

    hasSubscription = detail.hasSubscription;
    firstCartItemQuantity = detail.cart.items[0]?.quantity;
  });

  /** Script to Handle Delivery Date Storage & Navigation to Checkout **/

  // Uses Shopify's cart API to store the delivery date as a cart attribute.
  // Also stores when the delivery date was selected (for debugging purposes).
  const storeDeliveryDateAsCartAttribute = (deliveryDate, deliveryDateSelectionTime) => {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          deliveryDate,
          _deliveryDateSelectionTime: deliveryDateSelectionTime,
        },
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Uses Shopify's cart API to store the delivery date as a line item property.
  // Sets "isSubscription" to false since a delivery date cannot exist for a cart with a subscription.
  const storeDeliveryDateAsLineItemProperty = (deliveryDate) => {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: 1,
        quantity: firstCartItemQuantity ?? 1,
        properties: {
          _deliveryDate: deliveryDate,
          _isSubscription: 'false',
        },
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Stores the selected delivery date to the cart, then navigates to the checkout page.
  // Does NOT store the delivery date if the cart contains a subscription.
  checkoutButtonElement.querySelector('button').addEventListener('click', async () => {
    const deliveryDate = sessionStorage.getItem('deliveryDate');
    const deliveryDateSelectionTime = sessionStorage.getItem('deliveryDateSelectionTime');

    if (deliveryDate && !hasSubscription) {
      await storeDeliveryDateAsCartAttribute(deliveryDate, deliveryDateSelectionTime);
      await storeDeliveryDateAsLineItemProperty(deliveryDate);
    } else {
      await storeDeliveryDateAsCartAttribute(null, null);
    }

    window.location.href = '/checkout';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-delivery-date"]) return;
  try {
    
  /** Script to Handle Content Changes When All Subscriptions Are Removed & Update The Total Weight Variable **/

  const deliveryDateBodyTextElement = document.getElementById('delivery-date-body-text');
  const deliveryDateSubscriptionMessageElement = document.getElementById('delivery-date-subscription-message');
  const deliveryDateInputAndListWrapperElement = document.getElementById('delivery-date-input-and-list-wrapper');

  // Adds event listener to when the cart is updated.
  window.addEventListener('cart_changed', ({ detail }) => {
    if (!detail.hasSubscription) {
      if (deliveryDateBodyTextElement) {
        deliveryDateBodyTextElement.classList.remove('hidden');
      }

      if (deliveryDateSubscriptionMessageElement) {
        deliveryDateSubscriptionMessageElement.remove();
      }

      deliveryDateInputAndListWrapperElement.classList.replace('hidden', 'flex');
    }

    totalWeight = detail.cart.total_weight;
  });

  /** Script to Handle Delivery Date Fetching & Selection **/

  const zipInputElement = document.getElementById('zip-input');
  const zipInputErrorElement = document.getElementById('zip-input-error');
  const successMessageElements = document.querySelectorAll('.success-message');
  const deliveryDateListElement = document.getElementById('delivery-date-list');
  const expandListButtonElement = document.getElementById('expand-list-button');

  var zipUpdateTimeout;

  // Uses custom API to fetch available delivery dates for a given zip code.
  const fetchDeliveryDates = (zip, weight) => {
    return fetch(`https://api.houseofflowers.se/available-dates?zip=${zip}&weight=${weight || 0}`, {
      method: 'GET',
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Uses Shopify's cart API to "initiate the process of calculating delivery rates" (also saves the zip code).
  const prepareShippingRates = (zip) => {
    return fetch(
      window.Shopify.routes.root +
        `cart/prepare_shipping_rates.json?shipping_address%5Bzip%5D=${zip}&shipping_address%5Bcountry%5D=Sweden`,
      {
        method: 'POST',
      }
    )
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Adds event listener to the window object to fetch the previously selected delivery date from Session Storage.
  // If a delivery date is found, the delivery date list is updated to show the selected date.
  window.addEventListener('load', () => {
    const selectedDeliveryDate = sessionStorage.getItem('deliveryDate');

    if (selectedDeliveryDate) {
      deliveryDateListElement.dataset.selectedDeliveryDate = selectedDeliveryDate;

      deliveryDateListElement.innerHTML = `
        <li>
          <button 
            data-delivery-date="${selectedDeliveryDate}" 
            class="selected"
          >
            <span>${selectedDeliveryDate}</span>
            <span>Vald</span>
          </button>
        </li>
      `;
    }
  });

  // Adds event listener to the ZIP input element to fetch delivery dates when the ZIP is updated.
  // The delivery date list is updated with the available dates and the success message is shown.
  zipInputElement.addEventListener('input', ({ target }) => {
    clearTimeout(zipUpdateTimeout);

    zipUpdateTimeout = setTimeout(async () => {
      const zip = target.value;
      const selectedDeliveryDate = deliveryDateListElement.dataset.selectedDeliveryDate;

      successMessageElements.forEach((element) => {
        element.classList.add('hidden');
      });

      deliveryDateListElement.innerHTML = '';
      zipInputErrorElement.textContent = '';

      if (zip) {
        const { success, dates } = await fetchDeliveryDates(zip, totalWeight);

        if (success) {
          successMessageElements.forEach((element) => {
            element.textContent =
              dates.length === 0
                ? `Det finns inga tillgängliga leveransdatum för postnummer: ${zip}`
                : `Tillgängliga leveransdatum för postnummer: ${zip}`;

            element.classList.remove('hidden');
          });
        } else {
          zipInputErrorElement.textContent = 'Ogiltigt postnummer';
        }

        dates.forEach((date) => {
          deliveryDateListElement.innerHTML += `
            <li>
              <button 
                data-delivery-date="${date}" 
                class="${selectedDeliveryDate === date ? 'selected' : ''}"
              >
                <span>${date}</span>
                <span>${selectedDeliveryDate === date ? 'Vald' : 'Välj'}</span>
              </button>
            </li>
          `;
        });
      } else {
        if (selectedDeliveryDate) {
          deliveryDateListElement.innerHTML = `
            <li>
              <button 
                data-delivery-date="${selectedDeliveryDate}" 
                class="selected"
              >
                <span>${selectedDeliveryDate}</span>
                <span>Vald</span>
              </button>
            </li>
          `;
        }
      }

      if (deliveryDateListElement.children.length > 6) {
        expandListButtonElement.classList.remove('hidden');
      } else {
        expandListButtonElement.classList.add('hidden');
      }
    }, 500);
  });

  // Adds event listener to the delivery date list to select a delivery date.
  // The selected delivery date is saved to Session Storage and the shipping rates are prepared.
  deliveryDateListElement.addEventListener('click', ({ target }) => {
    if (target.tagName === 'BUTTON') {
      const deliveryDate = target.dataset.deliveryDate;
      const deliveryDateSelectionTime = new Date().toISOString();

      sessionStorage.setItem('deliveryDate', deliveryDate);
      sessionStorage.setItem('deliveryDateSelectionTime', deliveryDateSelectionTime);

      prepareShippingRates(zipInputElement.value);

      deliveryDateListElement.dataset.selectedDeliveryDate = deliveryDate;

      deliveryDateListElement.querySelectorAll('button').forEach((button) => {
        if (button === target) {
          button.classList.add('selected');
          button.querySelector('span:last-child').textContent = 'Vald';
        } else {
          button.classList.remove('selected');
          button.querySelector('span:last-child').textContent = 'Välj';
        }
      });
    }
  });

  // Adds event listener to the expand list button to toggle the expanding/collapsing of the delivery date list.
  expandListButtonElement.addEventListener('click', () => {
    const collapsed = deliveryDateListElement.classList.contains('collapsed');

    if (collapsed) {
      deliveryDateListElement.classList.remove('collapsed');
      expandListButtonElement.textContent = 'Visa färre datum';
    } else {
      deliveryDateListElement.classList.add('collapsed');
      expandListButtonElement.textContent = 'Visa fler tillgängliga datum';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-gift-info"]) return;
  try {
    
  const giftMessageInputElement = document.getElementById('gift-message-input');

  /** Script to Handle Content Changes When All Subscriptions Are Removed **/

  const giftMessageBodyTextElement = document.getElementById('gift-message-body-text');
  const giftMessageSubscriptionMessageElement = document.getElementById('gift-message-subscription-message');

  // Adds event listener to when the cart is updated.
  window.addEventListener('cart_changed', ({ detail }) => {
    if (!detail.hasSubscription) {
      if (giftMessageBodyTextElement) {
        giftMessageBodyTextElement.classList.remove('hidden');
      }

      if (giftMessageSubscriptionMessageElement) {
        giftMessageSubscriptionMessageElement.remove();
      }

      giftMessageInputElement.classList.replace('hidden', 'flex');
    }
  });

  /** Script to Handle Gift Message Updating **/

  var giftMessageUpdateTimeout;

  // Uses Shopify's cart API to store the gift message.
  const storeGiftMessage = (giftMessage) => {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: { giftMessage: giftMessage.substring(0, 200) } }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Updates the cart when the gift message input changes.
  giftMessageInputElement.addEventListener('input', ({ target }) => {
    clearTimeout(giftMessageUpdateTimeout);

    giftMessageUpdateTimeout = setTimeout(() => {
      storeGiftMessage(target.value);
    }, 500);
  });

  /** Script to Handle Phone Number Updating **/

  const phoneNumberInputElement = document.getElementById('phone-number-input');

  var phoneNumberUpdateTimeout;

  // Uses Shopify's cart API to store the phone number.
  const storePhoneNumber = (phoneNumber) => {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: { phoneNumber } }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Updates the cart when the gift message input changes.
  phoneNumberInputElement.addEventListener('input', ({ target }) => {
    clearTimeout(phoneNumberUpdateTimeout);

    phoneNumberUpdateTimeout = setTimeout(() => {
      storePhoneNumber(target.value);
    }, 500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-items"]) return;
  try {
    
  const cartListItems = document.querySelectorAll('#cart-list > li:not(#empty-cart)');

  // Uses Shopify's cart API to update a cart item's quantity.
  const updateCartItemQuantity = (id, quantity) => {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, quantity }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Adds event listeners to quantity update elements for all cart list items.
  cartListItems.forEach((lineItemElement) => {
    const id = lineItemElement.id;
    const removeButton = lineItemElement.querySelector('.remove-from-cart');
    const incrementButton = lineItemElement.querySelector('.increment-quantity');
    const decrementButton = lineItemElement.querySelector('.decrement-quantity');

    const removeFromCart = async () => {
      await updateCartItemQuantity(id, 0);
    };

    const updateQuantity = async (quantityChange) => {
      const quantity = parseInt(lineItemElement.dataset.quantity);
      const newQuantity = quantity + quantityChange;

      if (newQuantity > 0) {
        await updateCartItemQuantity(id, newQuantity);
        lineItemElement.dataset.quantity = newQuantity;
      }
    };

    removeButton.addEventListener('click', () => removeFromCart());
    incrementButton.addEventListener('click', () => updateQuantity(1));
    decrementButton.addEventListener('click', () => updateQuantity(-1));
  });

  // Listens for cart changes and updates the cart list accordingly.
  window.addEventListener('cart_changed', ({ detail }) => {
    const updatedCartItems = [...detail.added, ...detail.removed];
    const emptyCartElement = document.getElementById('empty-cart');
    const totalCartPriceElement = document.querySelector('.total-cart-price');

    if (updatedCartItems.length === 0) return;

    updatedCartItems.forEach(({ id }) => {
      const lineItemElement = document.getElementById(id);
      const quantityElement = lineItemElement.querySelector('.quantity');
      const totalLinePriceElement = lineItemElement.querySelector('.total-line-price');

      const lineItem = detail.cart.items.find((item) => item.id === id);
      const quantity = lineItem?.quantity ?? 0;
      const totalLinePrice = lineItem?.final_line_price ?? 0;

      if (quantity > 0) {
        quantityElement.textContent = `${quantity} st`;
        totalLinePriceElement.textContent = Shopify.formatMoney(totalLinePrice);
      } else {
        lineItemElement.remove();
      }
    });

    if (detail.cart.item_count === 0) {
      emptyCartElement.classList.remove('hidden');
    }

    totalCartPriceElement.textContent = Shopify.formatMoney(detail.cart.total_price);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-links"]) return;
  try {
    
  const collectionLinks = document.getElementById('collection-links');
  const scrollIndicator = document.getElementById('scroll-indicator');

  // Set the width of the scroll indicator based on the number of collection links.
  const setScrollIndicatorWidth = () => {
    const winWidth = window.innerWidth;

    if (scrollIndicator) {
      if (winWidth > 640) {
        scrollIndicator.style.width = `calc(400% / ${collectionLinks.children.length})`;
      } else {
        scrollIndicator.style.width = `calc(200% / ${collectionLinks.children.length})`;
      }
    }
  };

  window.addEventListener('load', setScrollIndicatorWidth);
  window.addEventListener('resize', setScrollIndicatorWidth);

  // When the collection links are scrolled, update the scroll indicator's position.
  if (collectionLinks) {
    collectionLinks.addEventListener('scroll', () => {
      const scrollPercentage = collectionLinks.scrollLeft / (collectionLinks.scrollWidth - collectionLinks.clientWidth);
      const scrollIndicatorWidth = scrollIndicator.clientWidth;
      const scrollIndicatorRailWidth = scrollIndicator.parentElement.clientWidth;

      scrollIndicator.style.left = `${(scrollIndicatorRailWidth - scrollIndicatorWidth) * scrollPercentage}px`;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"]) return;
  try {
    
  const quickAddToCartButtonElements = document.querySelectorAll('.quick-add-to-cart-button');

  // Uses Shopify's cart API to add a product to the cart.
  const addProductToCart = (id, quantity) => {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity }] }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  quickAddToCartButtonElements.forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();

      const productId = button.getAttribute('data-product-id');

      await addProductToCart(productId, 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"]) return;
  try {
    
  const quickAddToCartButtonElements = document.querySelectorAll('.quick-add-to-cart-button');

  // Uses Shopify's cart API to add a product to the cart.
  const addProductToCart = (id, quantity) => {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity }] }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  quickAddToCartButtonElements.forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();

      const productId = button.getAttribute('data-product-id');

      await addProductToCart(productId, 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /** Script to Handle Cart Item Count Updating **/

  const cartItemCountElement = document.getElementById('cart-item-count');

  window.addEventListener('cart_changed', ({ detail }) => {
    cartItemCountElement.textContent = detail.cart.item_count || '';
  });

  /** Script to Handle Dropdowns Showing **/

  const header = document.querySelector('header');
  const mainMenuLinks = document.querySelectorAll('#main-menu li');
  const dropdowns = document.querySelectorAll('#dropdown-wrapper > div');

  mainMenuLinks.forEach((link, i) => {
    if (link.classList.contains('has-child-links')) {
      const dropdown = dropdowns[i];

      link.addEventListener('mouseenter', () => {
        dropdown.classList.add('opacity-100', 'pointer-events-auto');
        link.classList.add('p-1.5xgutter', '-m-1.5xgutter');
      });

      header.addEventListener('mouseleave', () => {
        dropdown.classList.remove('opacity-100', 'pointer-events-auto');
        link.classList.remove('p-1.5xgutter', '-m-1.5xgutter');
      });

      header.addEventListener('mousemove', () => {
        if (!link.matches(':hover') && !dropdown.matches(':hover')) {
          dropdown.classList.remove('opacity-100', 'pointer-events-auto');
          link.classList.remove('p-1.5xgutter', '-m-1.5xgutter');
        }
      });
    }
  });

  /** Script to Handle Side Menu Toggling  **/

  const sideMenuToggleButton = document.getElementById('side-menu-toggle-button');

  var activeSideMenu = false;

  const toggleSideMenu = () => {
    const body = document.querySelector('body');
    const sideMenu = document.getElementById('side-menu');
    const sideMenuOpenIcon = sideMenuToggleButton.firstElementChild;
    const sideMenuCloseIcon = sideMenuToggleButton.lastElementChild;

    activeSideMenu = !activeSideMenu;

    if (activeSideMenu) {
      body.classList.add('overflow-y-hidden');
      sideMenu.classList.add('translate-x-full');

      sideMenuOpenIcon.classList.replace('flex', 'hidden');
      sideMenuCloseIcon.classList.replace('hidden', 'flex');
    } else {
      body.classList.remove('overflow-y-hidden');
      sideMenu.classList.remove('translate-x-full');

      sideMenuOpenIcon.classList.replace('hidden', 'flex');
      sideMenuCloseIcon.classList.replace('flex', 'hidden');
    }
  };

  sideMenuToggleButton.addEventListener('click', toggleSideMenu);

  /** Script to Handle Side Menu Submenu Toggling **/

  const sideMenuLinks = document.querySelectorAll('#side-menu li');
  const submenus = document.querySelectorAll('#side-menu-submenu-wrapper > div');
  const sideMenuMenuWrapper = document.getElementById('side-menu-menu-wrapper');
  const submenuBackButtons = document.querySelectorAll('#side-menu-submenu-wrapper button');

  sideMenuLinks.forEach((link, i) => {
    if (link.classList.contains('has-child-links')) {
      const submenu = submenus[i];

      link.addEventListener('click', () => {
        sideMenuMenuWrapper.classList.replace('flex', 'hidden');
        submenu.classList.replace('hidden', 'flex');
      });
    }
  });

  submenuBackButtons.forEach((button, i) => {
    const submenu = submenus[i];

    button.addEventListener('click', () => {
      sideMenuMenuWrapper.classList.replace('hidden', 'flex');
      submenu.classList.replace('flex', 'hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-form"]) return;
  try {
    
  window.onload = () => {
    (($) => {
      window.fnames = new Array();
      window.ftypes = new Array();
      fnames[0] = 'EMAIL';
      ftypes[0] = 'email';
      fnames[1] = 'FNAME';
      ftypes[1] = 'text';
      fnames[2] = 'LNAME';
      ftypes[2] = 'text';
      fnames[3] = 'ADDRESS';
      ftypes[3] = 'address';
      fnames[4] = 'PHONE';
      ftypes[4] = 'phone';
      fnames[5] = 'BIRTHDAY';
      ftypes[5] = 'birthday';
    })(jQuery);

    var $mcj = jQuery.noConflict(true);

    $mcj.extend($mcj.validator.messages, {
      required: 'Detta fält är obligatoriskt.',
      email: 'Vänligen ange en giltig e-postadress.',
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /** Script To Add Product to Cart **/

  const addToCartButtonElement = document.getElementById('add-to-cart-button');

  // Uses Shopify's cart API to add a product to the cart.
  const addProductToCart = (formData) => {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  if (addToCartButtonElement) {
    addToCartButtonElement.addEventListener('click', async () => {
      const addToCartForm = document.querySelector('form[action$="/cart/add"]');

      if (!addToCartForm) return;

      const formData = new FormData(addToCartForm);
      await addProductToCart(formData);
    });
  }

  /** Script To Handle Product Image Carousel Scrolling **/

  const productImageCarousel = document.getElementById('product-image-carousel');
  const previousImageButton = document.getElementById('previous-image-button');
  const nextImageButton = document.getElementById('next-image-button');

  const scrollImageCarousel = (direction) => {
    if (!productImageCarousel) return;

    const imageCount = productImageCarousel.childElementCount || 1;
    const scrollAmount = productImageCarousel.clientWidth / imageCount;

    productImageCarousel.scrollBy({
      left: direction * scrollAmount,
      behavior: 'smooth'
    });
  };

  if (previousImageButton && nextImageButton && productImageCarousel) {
    previousImageButton.addEventListener('click', () => scrollImageCarousel(-1));
    nextImageButton.addEventListener('click', () => scrollImageCarousel(1));
  }

  const scrollButtonVisibility = () => {
    if (!productImageCarousel || !previousImageButton || !nextImageButton) return;

    const scrollLeft = productImageCarousel.scrollLeft;
    const scrollWidth = productImageCarousel.scrollWidth;
    const clientWidth = productImageCarousel.clientWidth;

    if (scrollLeft === 0) {
      previousImageButton.classList.add('opacity-0', 'pointer-events-none');
    } else {
      previousImageButton.classList.remove('opacity-0', 'pointer-events-none');
    }

    if (scrollLeft + clientWidth >= scrollWidth) {
      nextImageButton.classList.add('opacity-0', 'pointer-events-none');
    } else {
      nextImageButton.classList.remove('opacity-0', 'pointer-events-none');
    }
  };

  if (productImageCarousel) {
    productImageCarousel.addEventListener('scroll', scrollButtonVisibility);
    // Run once on load so state is correct if already scrolled
    scrollButtonVisibility();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"]) return;
  try {
    
  /** Script To Add Products to Cart  **/

  const initQuickAddToCartButtons = () => {
    const quickAddToCartButtonElements = document.querySelectorAll('.quick-add-to-cart-button');

    // Uses Shopify's cart API to add a product to the cart.
    const addProductToCart = (id, quantity) => {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }] }),
      })
        .then((response) => {
          return response.json();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    quickAddToCartButtonElements.forEach((button) => {
      button.addEventListener('click', async (event) => {
        event.preventDefault();

        const productId = button.getAttribute('data-product-id');

        await addProductToCart(productId, 1);
      });
    });
  };

  /** Script To Fetch The Recommendations **/

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('#product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          initQuickAddToCartButtons();
        }
      })
      .catch((e) => {});
  };

  const productRecommendationsSection = document.querySelector('#product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 400px 0px' });

  if (productRecommendationsSection) {
    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
